<template lang="pug">
    .container.content
        .column.is-offset-1.is-10
            ul.no-style-list
                MediaPreview(
                    v-for="content in contents" :key="content.id"
                    :media="content.media[0]"
                    :height="64"
                    :width="61"
                )
</template>

<script>
import _ from 'lodash'

import MediaPreview from './MediaPreview'

export default {
    name: 'Downloads',
    props: {
        section: {
            type: Object,
            required: true,
        },
    },
    components: {
        MediaPreview
    },
    computed: {
        contents() {
            let contents = _.get(this.section, 'contents') || []

            const isValidMediaObject = media => {
                let isValid = false
                switch (media.type) {
                    case 'file':
                        isValid = !! _.get(media, 'file')
                        break
                    case 'image':
                    case 'video':
                        isValid = !! _.get(media, `${media.type}.source`)
                        break
                }
                return isValid
            }


            contents = _.cloneDeep(contents).filter(content => {
                return content.media && content.media.length === 1 &&
                    isValidMediaObject(content.media[0])
            }).sort((a, b) => _.get(a, 'position', 0) - _.get(b, 'position', 0))

            return contents
        }
    }
}
</script>

<style lang="sass" scoped></style>
